import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { rgba } from 'polished'

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Section = styled.div`
  /* border: 1px solid red; */
`

export const StyledGridItem = styled(Grid)`
  margin-bottom: 16px;
  @media (max-width: 959px) {
    margin-bottom: 8px;
  }
`

type InputWrapperProps = {
  minHeight?: string
  error?: boolean
}

export const InputWrapper = styled.div<InputWrapperProps>`
  padding: 16px;
  border: 1px solid
    ${({ theme, error }) => (error ? theme.ds.colors.danger300 : '#e0e0e0')};
  border-radius: 8px;
  min-height: ${({ minHeight }) => minHeight || '168px'};

  @media (max-width: 959px) {
    min-height: unset;
  }
`

export const CardHospitalizedInfo = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.ds.colors.infoBackground};
  border: 1px solid ${({ theme }) => rgba(theme.ds.colors.infoBorder, 0.3)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

type RadioGroupProps = {
  justifyContent?: 'space-between' | 'flex-start' | 'center'
}

export const RadioGroup = styled.div<RadioGroupProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 430px) {
    gap: 0;
    flex-direction: column;
    align-items: flex-start;
  }
`

type InputGroupProps = {
  marginTop?: string
}

export const InputGroup = styled.div<InputGroupProps>`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: ${({ marginTop }) => marginTop || '0'};

  > div:nth-child(1) {
    flex: 3;
  }

  > div:nth-child(2) {
    flex: 1;
  }

  @media (max-width: 959px) {
    margin-top: 0;
  }

  @media (max-width: 430px) {
    gap: 4px;
  }
`

export const ArrowIconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  svg path {
    fill: ${({ theme }) => theme.ds.colors.textSecondary};
  }

  svg:first-child {
    transform: scaleY(-1);
  }
`
